// extracted by mini-css-extract-plugin
export var phone = "_2e-0";
export var phoneDragging = "_2e-1";